import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import state from "./state";
import mutations from "./mutations";
import getters from "./getters";

// Admin vuex Modules
import baseX from "./modules/baseX";
import supportX from "./modules/supportX";
import hrX from "./modules/hrX";
import financeX from "./modules/financeX";

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    baseX,
    supportX,
    hrX,
    financeX,
  },
});
